import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgListBulleted = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentcolor",
		fillRule: "evenodd",
		d: "M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z",
		clipRule: "evenodd"
	})
});
export default SvgListBulleted;
